module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"entity_id":"Afflo ID"},"fr":{"entity_id":"No Afflo"},"en_tgln":{"entity_id":"TGLN ID"},"fr_tgln":{"entity_id":"No TGLN"},"en_tq":{"entity_id":"TQ Number"},"fr_tq":{"entity_id":"No TQ"}}')
  delete Component.options._Ctor
}
